export default __webpack_public_path__ + "static/media/close-icon-blue.0a46ee54.svg";